export default [
    {
        key: "row_selected",
        label: app.$i18n.t(""),
        sortable: false,
        visible: true,
    },
    {
        // [0]
        key: "document",
        label: app.$i18n.t("Document"),
        visible: true,
        sortable: true,
    },
    {
        // [1]
        key: "load_date",
        label: app.$i18n.t("Programming"),
        visible: true,
        thClass: "text-center",
        sortable: true,
    },
    {
        // [1]
        key: "transport_number",
        label: app.$i18n.t("Transporte number"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },
    {
        // [2]
        key: "service_order_code",
        label: app.$i18n.t("Service code"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },
    {
        // [1]
        key: "remittance_number",
        label: app.$i18n.t("Remittance number"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },
    {
        // [1]
        key: "quantity",
        label: app.$i18n.t("Quantity"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },
    {
        // [1]
        key: "volume",
        label: app.$i18n.t("Volume"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },
    {
        // [1]
        key: "weight",
        label: app.$i18n.t("Weight"),
        visible: true,
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
    },

    // {
    //     // [3]
    //     key: "documents_orders",
    //     label: app.$i18n.t("Documents Orders"),
    //     visible: true,
    //     thClass: "text-center",
    //     tdClass: "text-center",
    //     sortable: true,
    // },
    // {
    //     // [4]
    //     key: "created_at",
    //     label: app.$i18n.t("Created At"),
    //     visible: true,
    //     thClass: "text-left",
    //     tdClass: "text-left",
    // },
    // {
    //     // [5]
    //     key: "actions",
    //     label: app.$i18n.t("actions"),
    //     visible: true,
    //     thClass: "text-center",
    //     tdClass: "text-center",
    // },
];
